import React from 'react';
import { useState, useEffect, useFormContext, Hooks, Code, Form, Field, Name, Title, Actions, Toast, API, Utility, Button, Files, Control, OptionType } from 'helpers/FormImports';
import { Messages } from 'components/common/MessageManager';
import { Template } from 'models/TemplateModel';
import HtmlEditor from 'components/common/HtmlEditor';


const TemplateForm: React.FC = () => {
  const [formId, formName] = [Code.Form.Id.TEMPLATE, Code.Form.Name.TEMPLATE];
  const {keyId, activeId, setActiveId, loading, setLoading, message, setMessage, showMenu, setShowMenu, confirm, setConfirm, error, setError, menuPosition, setMenuPosition, contextMenuRef, iframeRef, formRef } = useFormContext();
  const [activeTab, setActiveTab] = useState<string>(Utility.Storage.GetTab(formName));
  const [typeOptions, setTypeOptions] = Hooks.Form.Options();
  const [actionOptions, setActionOptions] = Hooks.Form.Options();
  const [defaultOptions, setDefaultOptions] = Hooks.Form.Options();
  const [columnOptions, setColumnOptions] = Hooks.Form.Options();
  const [formData, setFormData] = useState<Template>({});
  const [templateData, setTemplateData] = useState<string | undefined>(undefined);
  const [selectedColumn, setSelectedColumn] = useState<string>('');
    
  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  Hooks.Privilege.HasOpen(Privilege);
  
  useEffect(() => {
    Files.Json.Http(Code.File.TEMPLATE+Code.File.TYPE, Code.Option.Common.SELECT, setTypeOptions, setError);
    Files.Json.Http(Code.File.TEMPLATE+Code.File.ACTION, Code.Option.Common.NA, setActionOptions, setError);
    Files.Json.Http(Code.File.DEFAULT, Code.Option.Common.NA, setDefaultOptions, setError);
    Files.Json.Http(Code.File.TEMPLATE+Code.File.COLUMN, Code.Option.Common.SELECT, setColumnOptions, setError);
  
    API.Data.GetByKeyId<Template>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
        setActiveId(data.template_active); 
        const formData = await Form.Map.Data(data);
        setTemplateData(data.template_data);
        setFormData((prevData) => ({
          ...prevData,
          ...formData,
        }));
      }})
      setLoading(false);
  }, []);

   useEffect(() => {
      if(selectedColumn){
        console.log("selectedColumn:",selectedColumn);
        navigator.clipboard.writeText(`{{${selectedColumn}}}`);
      }
      
   }, [selectedColumn]); 

  const onSubmit = async (e: React.FormEvent) => {
    if (!Toast.Validate.Form(e,setMessage)) return;
    const addonData = await API.Data.AddonData(formData, formName, keyId);
    const finalData = Utility.Sanitize.FormData({
      ...formData,
      ...addonData,
      template_name: Utility.Convert.TitleCase(formData.template_name),
      template_data: templateData,
    });
    API.Data.Save(formName, keyId, finalData, setMessage)
  };

  return (
    <Control.Form.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      <Messages.Toast Messages={message} Error={error} />
      <Messages.Confirm Messages={confirm} onConfirm={() => API.Data.Delete(formName, keyId, activeId, setMessage)} onRefuse={()=>{}} />
      {!loading && (
        <form id={Code.Form.Name.EDIT} ref={formRef} onSubmit={onSubmit} autoComplete="off">
          <Button.Save keyId={keyId} activeId={activeId} handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} formName={formName} formId={formId} Privilege={Privilege} />
          <Control.Tab.Header titles={["Details"]} activeTab={activeTab} formName={formName} setActiveTab={setActiveTab} />
          <Control.Form.Data>
 
            <Control.Tab.Content id={Code.Tab.Tab1} isActive={activeTab === Code.Tab.Tab1}>
              <Control.Row>
                <Field.Select id={Name.Common.TypeId} value={formData.type_id} title={Title.Mode} options={typeOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[0,50,1]} require={true} />
                <Field.Select id={Name.Template.ActionId} value={formData.action_id} title={"Act On"} options={actionOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,25,1]} />
                <Field.Select id={Name.Common.DefaultId} value={formData.default_id} title={"Set As Default"} options={defaultOptions}  onChange={(e) => Form.Field.Change(e, formData, setFormData)} size={[1,25,0]} />
              </Control.Row>
              <Control.Box>
                <Field.Text id={Name.Template.Name} value={formData.template_name} title="Template Name" onChange={(e) => Form.Field.Change(e, formData, setFormData)} require={true} />
                <HtmlEditor content={templateData} setContent={setTemplateData}/>
              </Control.Box>
              <Control.Row>
                <Field.Title title={"Select Exam Field"} size={[0,50,1]} align={Code.Align.RIGHT} />
                <Field.FilterSelect id={"column_list"} value={selectedColumn} options={columnOptions} setSelectedId={setSelectedColumn} size={[1,50,0]} />
              </Control.Row>
              <Control.Box>
                <Field.Area id={Name.Template.Comment} value={formData.template_comment} title={Title.Comment} onChange={(e) => Form.Field.Change(e, formData, setFormData)} />
              </Control.Box>
            </Control.Tab.Content>
 
          </Control.Form.Data>
        </form>
      )}
      {showMenu && (<div ref={contextMenuRef}><Control.FormContextMenu keyId={keyId} activeId={activeId} showMenu={showMenu} formName={formName}  handleDelete={() => Toast.Delete.CurrentRecord(activeId, setConfirm)} setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Form />
    </Control.Form.Frame>
  );
};

export default TemplateForm;